/* global getURLParameter, initFancybox, device, setCookie, getCookie, deleteCookie */

const PATH_BEFORE_AUTHORIZATION = 'path_before_authorization';

$(document).ready(function () {
    showErrorMessage();
    setAnchorBeforeAuthorization();

    if (typeof initFancybox !== 'undefined') {
        // библиотека fancybox подключается только на разработке
        $(document).on('click', '.fancybox', function (e) {
            const $this = $(this);

            if (typeof $this.data('fancybox') === 'undefined') {
                // проверяем не был ли уже инициализирован fancybox на элементе
                e.preventDefault();

                initFancybox($this);
                $this.trigger('click');
            }
        });

        initFancybox();
    }

    $('#formlogin').on('submit', function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: '/login/auth',
            data: {
                login: $('#log').val(),
                password: $('#nam').val()
            },
            success: function (response) {
                if (response && response.success) {
                    location.href = '/';
                } else {
                    const text_error = (response && response.fail ? response.fail : response);

                    if (typeof device !== 'undefined' && device.type === 'mobile') {
                        $('.error_for_mobile').text(text_error);
                    } else {
                        Swal.fire({
                            title: 'Ошибка',
                            html: text_error,
                            icon: 'error'
                        });
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                Swal.fire({
                    title: 'Внимание!',
                    html: 'Возникла ошибка: ' + jqXHR.responseCode + '; Текст ошибки: ' + textStatus,
                    icon: 'error'
                });
            }
        });

        return false;
    });
});

/**
 * ???
 */
function showErrorMessage() {
    const FORCED_LOGOUT = 5;

    if (location.hash != '' && location.hash.indexOf('error/') !== -1) {
        const array = location.hash.split('/');
        let message = '';

        if (array[1] == FORCED_LOGOUT) {
            message = 'Сеанс работы завершен принудительно. Причина: кто-то другой вошел в ваш аккаунт используя тот же логин и пароль. '
                + 'Возможно это сделали вы (например на другом компьютере или в другом браузере). '
                + 'Если вам неизвестно кто вошел под вашим логином и паролем, рекомендуем сменить пароль. '
                + 'Если вы недавно обращались в службу технической поддержки с какой-либо проблемой и предоставили свой логин и пароль, '
                + 'то возможно это наши специалисты занимаются устранением вашей проблемы.';
        } else {
            message = decodeURIComponent(array[1]);
        }

        Swal.fire({title: 'Внимание', html: message, icon: 'warning'}).then(() => {
            window.location.hash = '';
        });
    }
}

/**
 *
 * @param {Number} type
 * @param {String} id
 */
function CheckInput(type, id) {
    const cmp_int_string = /^([0-9_])+$/i;
    const cmp_rus_string = /^([а-я _-]+\.)*[А-Я _-]+$/i;
    const cmp_mail_string = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@([a-z0-9][a-z0-9-]*[a-z0-9]\.)+[a-z]{2,4}$/i;
    let cmpstring;

    switch (type) {
        case 1:
            cmpstring = cmp_int_string;
            break;
        case 2:
            cmpstring = cmp_rus_string;
            break;
        case 3:
            cmpstring = cmp_mail_string;
            break;
    }

    const chkstring = $('#' + id).val();

    if (cmpstring.test(chkstring) === false) {
        $('#' + id).addClass('wrong');
    } else {
        $('#' + id).removeClass('wrong');
    }
}

/**
 *
 * @param {String} url
 * @param {String} selector
 */
function load_news(url, selector) {
    const news_block = $(selector);
    let news_item = '';
    let date_month;

    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: url,
        data: {
            items_on_page: 4
        },
        success: function (result) {
            if (result.error) {
                console.error('Не удалось загрузить новости: ' + result.error);
                news_block.html('<div>Произошла ошибка при загрузке новостей</div>');
            } else if (news_block && news_block.length) {
                for (const index in result.items) {
                    /* Дата приходит в формате DD.MM.YY удаляем последний элемент - год, преобразуем к формату DD.MM*/
                    date_month = result.items[index].date.split('.');
                    date_month.pop();
                    news_item += '<div class="news-item"><div class="date">' + date_month.join('.') + '</div>'
                        + '<a class="write-message-link" href="' + result.items[index].href + '">' + result.items[index].text + '</a>'
                        + '</div>';
                }

                news_block.html(news_item);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (news_block && news_block.length) {
                news_block.html('<div>Произошла ошибка при загрузке новостей</div>');
            }

            console.error('Не удалось загрузить новости: ' + jqXHR.responseCode + '; Текст ошибки: ' + textStatus);
        }
    });
}

/**
 * Сохранение якоря страницы в куках
 */
function setAnchorBeforeAuthorization() {
    const path_before_authorization = getCookie(PATH_BEFORE_AUTHORIZATION);

    if (path_before_authorization && document.location.hash.length > 0) {
        const full_path_before_authorization = path_before_authorization + document.location.hash;

        deleteCookie(PATH_BEFORE_AUTHORIZATION);

        setCookie(PATH_BEFORE_AUTHORIZATION, full_path_before_authorization, (new Date).getTime() + 300000, '/'); // Время жизни куки 5 мин
    }
}
